import { Component, OnInit } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd";
import { Department } from "@app/_models/_DTOs/department";
import { DepartmentService } from "@app/_services/department.service";
import { ITuple } from "@app/_models/tuple";
import { Sort } from "@app/_models/sort";
import { SortDirection } from "@app/_models/enums/sortDirection";
import { DepartmentViewModel } from "@app/_models/_viewModels/department.viewmodel";
import { BaseComponent } from "@app/_shared/base.component";
import { SCREEN_SIZE } from "@app/_helpers/screen-size.enum";
import { UserToken } from "@app/_models";
import { AuthenticationService } from "@app/_services";
import { ResizeService } from "@app/_services/resize.service";
import { LegalEntity } from "@app/_models/_DTOs/legalEntity";
import { LegalEntityService } from "@app/_services/legalEntity.service";

@Component({
  selector: "app-departments",
  templateUrl: "./departments.component.html",
  styleUrls: ["./departments.component.css"],
})
export class DepartmentsComponent extends BaseComponent implements OnInit {
  onScreenResize(screenSize: SCREEN_SIZE) {}
  onUserAvailable(userToken: UserToken) {}
  level: number = 0;

  sorts: Sort[] = [];
  pageIndex = 1;
  pageSize = 10;
  total = 1;
  departmentList: Department[] = [];
  loading = true;

  detailsDrawerVisible: boolean = false;
  editDrawerVisible: boolean = false;
  isSavingDepartment: boolean = false;
  isEditing: boolean = false;

  selectedDepartment: Department;
  departmentViewModel: DepartmentViewModel = null;

  legalEntities: LegalEntity[] = [];

  nameSearchValue = "";
  legalEntityIdSearchValue: number[] = [];

  errorMessages = {};

  constructor(
    private departmentService: DepartmentService,
    private messageService: NzMessageService,
    private legalEntityService: LegalEntityService,
    protected authenticationService: AuthenticationService,
    protected resizeService: ResizeService
  ) {
    super(authenticationService, resizeService);
  }

  ngOnInit() {
    this.loadDataForDropdowns();
    this.searchData();
  }

  initModel(department?: Department) {
    if (department) {
      this.isEditing = true;
      this.departmentViewModel = {
        id: department.id ? department.id : -1,
        name: department.name ? department.name : "",
        legalEntityId: department.legalEntity ? department.legalEntity.id : -1,
        isDefaultForUnassigned: department.isDefaultForUnassigned
      };
    } else {
      this.isEditing = false;
      this.departmentViewModel = {
        id: -1,
        name: "",
        legalEntityId: -1,
        isDefaultForUnassigned: false
      };
    }
  }

  loadDataForDropdowns() {
    this.legalEntityService.getAllBasic().subscribe((data: LegalEntity[]) => {
      this.legalEntities = data;
    });
  }

  openCreateDepartmentForm() {
    this.isEditing = false;
    this.initModel();
  }

  editDepartment(department: Department) {
    this.initModel(department);
  }

  deleteDepartment(id: number) {
    this.departmentService.delete(id).subscribe(
      (result) => {
        this.messageService.create("success", "Pravna osoba uspješno obrisana");
        this.searchData();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  sort(sort: { key: string; value: string }): void {
    var newSort: Sort = {
      PropertyName: sort.key,
      Direction: null,
    };
    if (sort.value) {
      if (sort.value == "ascend") {
        newSort.Direction = SortDirection.Ascending;
      } else {
        newSort.Direction = SortDirection.Descending;
      }
    }

    if (newSort.Direction == null) {
      var existingSort = this.sorts.find(
        (x) => x.PropertyName == newSort.PropertyName
      );
      if (existingSort) {
        const index = this.sorts.indexOf(existingSort);
        if (index > -1) {
          this.sorts.splice(index, 1);
        }
      }
    } else {
      var existingSort = this.sorts.find(
        (x) => x.PropertyName == newSort.PropertyName
      );
      if (existingSort) {
        existingSort.Direction = newSort.Direction;
      } else {
        this.sorts.push(newSort);
      }
    }
    this.searchData();
  }

  getSortString() {
    var sortString = "";
    if (this.sorts && this.sorts.length > 0) {
      for (let sort of this.sorts) {
        if (sort.Direction == SortDirection.Ascending) {
          if (sortString.length == 0) {
            sortString = sort.PropertyName;
          } else {
            sortString += "," + sort.PropertyName;
          }
        } else {
          if (sortString.length == 0) {
            sortString = "-" + sort.PropertyName;
          } else {
            sortString += ",-" + sort.PropertyName;
          }
        }
      }
    }
    return sortString;
  }

  searchData(reset: boolean = false): void {
    if (reset) {
      this.pageIndex = 1;
    }

    var filters = "";
    if (this.nameSearchValue.length > 0) {
      filters += "Name@=" + this.nameSearchValue + ",";
    }
    if (this.legalEntityIdSearchValue.length > 0) {
      filters +=
        "LegalEntityId==" +
        this.legalEntityIdSearchValue.join("|") +
        ",";
    }

    var sortString = this.getSortString();
    if (sortString.length == 0) {
      sortString = "-Created";
    } else {
      sortString += ",-Created";
    }

    this.loading = true;
    this.departmentService
      .getPage(this.pageIndex, this.pageSize, sortString, filters)
      .subscribe((data: ITuple<Department>) => {
        this.loading = false;
        this.total = data.item2;
        this.departmentList = data.item1;
      });
  }

  reset(): void {
    this.nameSearchValue = "";
    this.legalEntityIdSearchValue = [];
    this.searchData(true);
  }

  openDetails(department: Department) {
    // this.departmentService
    //   .get(department.id)
    //   .subscribe((data: Department) => {
    //     this.selectedDepartment = data;
    //   });
  }

  closeDetails() {
    this.selectedDepartment = null;
  }

  closeEditDrawer(reload: boolean) {
    this.departmentViewModel = null;
    this.isEditing = false;
    if (reload) {
      this.searchData();
    }
  }
}
